import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import {
  getListUsersQueryKey,
  type UpdateUserMutationError,
  useUpdateUser,
} from '@/entities/tenantusers/api/generated/api';
import { UserDomainErrorCode } from '@/entities/tenantusers/api/generated/model';
import { toast } from '@/shared/ui';

export const useUserEditMutation = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const userTitle = t('user-management.navigation.title');

  return useUpdateUser({
    request: { suppressToast: true },
    mutation: {
      onSuccess: () => {
        toast.success(t('common.messages.update-success', { name: userTitle }));
        queryClient.invalidateQueries({ queryKey: getListUsersQueryKey() });
        onSuccess();
      },
      onError: (error: UpdateUserMutationError) => {
        // 自分自身の無効化は API 側でも保護されている
        const domainCode = error.response?.data.domain_error?.code;
        if (domainCode === UserDomainErrorCode.CANNOT_DEACTIVATE_SELF) {
          toast.error(t('user-management.users.edit.cannot-deactivate-self'));
          return;
        }
        toast.error(t('common.messages.update-failed', { name: userTitle }));
      },
    },
  });
};
